import { render, staticRenderFns } from "./AppCustomBars.vue?vue&type=template&id=71ca9344&scoped=true"
import script from "./AppCustomBars.vue?vue&type=script&lang=ts"
export * from "./AppCustomBars.vue?vue&type=script&lang=ts"
import style0 from "./AppCustomBars.vue?vue&type=style&index=0&id=71ca9344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca9344",
  null
  
)

export default component.exports